// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const Return = createSvgIcon(
  { LeftToRight: <React.Fragment><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20.4857 19C22.0564 17.0981 23 14.6593 23 12c0-6.0751-4.9249-11-11-11-3.8615 0-7.2584 1.9898-9.221 5" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2 3v4h4" /><path stroke="currentColor" strokeDasharray="2 4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.5143 19C5.532 21.443 8.5841 23 12 23c3.4159 0 6.4681-1.557 8.4857-4" /></React.Fragment>, },
  'default'
);
